import React from "react";
import img from "../Assets/enquiry.jpg";

const Enquiry = () => {
  return (
    <section className="w-full bg-gray-100">

      {/* TOP IMAGE BANNER */}
      <div className="relative w-full h-[220px] md:h-[300px] lg:h-[350px]">
        <img
          src={img}
          alt="Enquiry Banner"
          className="w-full h-full object-cover"
        />

        <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
          <h2 className="text-white text-2xl md:text-3xl font-bold">
            Get in Touch With Us
          </h2>
        </div>
      </div>

      {/* FORM SECTION */}
      <div className="max-w-3xl mx-auto px-5 py-12">

        <div className="bg-white rounded-xl shadow-md p-6 md:p-10">

          <form className="grid grid-cols-1 md:grid-cols-2 gap-4">

            <input
              type="text"
              placeholder="Name"
              className="w-full border rounded-lg px-4 py-3 focus:ring-2 focus:ring-blue-500 outline-none"
            />

            <input
              type="email"
              placeholder="Email"
              className="w-full border rounded-lg px-4 py-3 focus:ring-2 focus:ring-blue-500 outline-none"
            />

            <input
              type="tel"
              placeholder="Phone"
              className="w-full border rounded-lg px-4 py-3 focus:ring-2 focus:ring-blue-500 outline-none"
            />

            <select className="w-full border rounded-lg px-4 py-3 focus:ring-2 focus:ring-blue-500 outline-none">
              <option>Select Service</option>
              <option>SEO</option>
              <option>Social Media Marketing</option>
              <option>Performance Marketing</option>
              <option>Web Development</option>
              <option>Graphic Design</option>
            </select>

            <textarea
              rows="4"
              placeholder="Message"
              className="md:col-span-2 w-full border rounded-lg px-4 py-3 focus:ring-2 focus:ring-blue-500 outline-none"
            />

            <button
              type="submit"
              className="md:col-span-2 bg-[#f99728] hover:bg-blue-700 text-white py-3 rounded-lg font-semibold transition"
            >
              Send Enquiry
            </button>

          </form>
        </div>

      </div>
    </section>
  );
};

export default Enquiry;